module.exports = __webpack_public_path__ + "static/media/amazon-logo.7451f65b.png";